import { vShow as _vShow, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-03eda274"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tooltip-content" }
const _hoisted_2 = {
  class: "gordita-500-11-m",
  "data-testid": "helper-cores-labeled-tooltip-text"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IncrediTooltip = _resolveComponent("IncrediTooltip")!

  return (_openBlock(), _createBlock(_component_IncrediTooltip, {
    modelValue: _ctx.localModelValue,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.localModelValue) = $event)),
    delay: 200,
    hover: "",
    direction: "bottom-middle",
    "offset-y": 28
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t('dashboard.top.topRightBars.tooltip.helperCoresTooltip')), 1)
      ])
    ]),
    default: _withCtx(() => [
      _withDirectives(_createElementVNode("i", {
        class: _normalizeClass(`uil uil-info-circle text-[${_ctx.iconSize}]`),
        style: _normalizeStyle({ color: _ctx.COLORS['Text/text_medium'] }),
        "data-testid": "helper-cores-labeled-icon-close"
      }, null, 6), [
        [_vShow, !_ctx.modelValue]
      ]),
      _withDirectives(_createElementVNode("i", {
        style: _normalizeStyle({ color: _ctx.COLORS['Text/text_medium'] }),
        class: _normalizeClass(`uis uis-info-circle text-[${_ctx.iconSize}]`),
        "data-testid": "helper-cores-labeled-icon-open"
      }, null, 6), [
        [_vShow, _ctx.modelValue]
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}